export const SCOPING_STAGES = [
  "1. New","2. Customer Info","3. Estimation",
  "4. Proposal","5. Developer Matching","6. Meeting","7. Done","8. Lost",
];

export const SCOPING_STAGE_TEAM = {
  "1. New":               { team:"Sales",       defaultAssignee:"Lars Strand"       },
  "2. Customer Info":     { team:"Sales",       defaultAssignee:"Lars Strand"       },
  "3. Estimation":        { team:"Delivery",    defaultAssignee:"Marcus Webb"       },
  "4. Proposal":          { team:"Sales",       defaultAssignee:"Vilhelm Sturén"    },
  "5. Developer Matching":{ team:"Recruitment", defaultAssignee:"Sameer Goumaa"     },
  "6. Meeting":           { team:"Sales",       defaultAssignee:"Lars Strand"       },
  "7. Done":              { team:"Operations",  defaultAssignee:"Connor de Freene"  },
  "8. Lost":              { team:"Sales",       defaultAssignee:"Lars Strand"       },
};

export const LEAD_STATUSES = [
  "NEW","INITIAL CONTACT","FIRST MEETING BOOKED","IN HUBSPOT","LOST",
];

export const LEAD_STAGE_DEPT = {
  "NEW":                  { dept:"Sales", defaultOwner:"Connor de Freene" },
  "INITIAL CONTACT":      { dept:"Sales", defaultOwner:"Lars Strand"      },
  "FIRST MEETING BOOKED": { dept:"Sales", defaultOwner:"Lars Strand"      },
  "IN HUBSPOT":           { dept:"Sales", defaultOwner:"Vilhelm Sturén"   },
  "LOST":                 { dept:"Sales", defaultOwner:"Lars Strand"      },
};

export const LEAD_STAGE_TASKS = {
  "NEW": [
    { title:"Research company background",    dept:"Sales" },
    { title:"Identify key decision makers",   dept:"Sales" },
    { title:"Prepare outreach message",       dept:"Sales" },
    { title:"Log lead in CRM",               dept:"Sales" },
  ],
  "INITIAL CONTACT": [
    { title:"Send introduction email",                  dept:"Sales" },
    { title:"Follow up on initial outreach",            dept:"Sales" },
    { title:"Qualify lead (budget, timeline, need)",    dept:"Sales" },
    { title:"Schedule first meeting",                   dept:"Sales" },
  ],
  "FIRST MEETING BOOKED": [
    { title:"Prepare meeting agenda & deck",           dept:"Sales"     },
    { title:"Research pain points & use cases",        dept:"Sales"     },
    { title:"Conduct discovery meeting",               dept:"Sales"     },
    { title:"Send meeting recap & next steps",         dept:"Sales"     },
    { title:"Assess fit for Value Scan or scoping",    dept:"Delivery"  },
  ],
  "IN HUBSPOT": [
    { title:"Create HubSpot deal record",          dept:"Sales" },
    { title:"Assign deal pipeline stage",          dept:"Sales" },
    { title:"Set up automated nurture sequence",   dept:"Sales" },
    { title:"Schedule follow-up cadence",          dept:"Sales" },
  ],
  "LOST": [
    { title:"Document reason for loss",                    dept:"Sales" },
    { title:"Schedule re-engagement check (90 days)",      dept:"Sales" },
  ],
};

export const AUDIT_STATUSES = [
  "Questionnaire","Interviews","Done","General Task",
];

export const AUDIT_STAGE_DEPT = {
  "Questionnaire": { dept:"Delivery",   defaultAssignee:"Marcus Webb"      },
  "Interviews":    { dept:"Delivery",   defaultAssignee:"Marcus Webb"      },
  "Done":          { dept:"Operations", defaultAssignee:"Connor de Freene" },
  "General Task":  { dept:"Operations", defaultAssignee:""                 },
};

export const AUDIT_STAGE_TASKS = {
  "Questionnaire": [
    { title:"Send audit questionnaire",         dept:"Delivery"   },
    { title:"Schedule initial briefing",        dept:"Delivery"   },
    { title:"Collect completed questionnaire",  dept:"Delivery"   },
    { title:"Create Google Drive folder",       dept:"Operations" },
    { title:"Send NDA",                         dept:"Sales"      },
  ],
  "Interviews": [
    { title:"Schedule stakeholder interviews",  dept:"Delivery" },
    { title:"Conduct technical interviews",     dept:"Delivery" },
    { title:"Document findings",                dept:"Delivery" },
    { title:"Prepare interview summary",        dept:"Delivery" },
  ],
  "Done": [
    { title:"Deliver final report",   dept:"Delivery"   },
    { title:"Conduct debrief call",   dept:"Sales"      },
    { title:"Log outcome in CRM",     dept:"Operations" },
  ],
  "General Task": [
    { title:"Define task scope", dept:"Operations" },
    { title:"Assign owner",      dept:"Operations" },
  ],
};
